module.exports = __webpack_public_path__ + "img/ticket.e4186131.png";